<a [routerLink]="['..']" class="adap-link link-return">
    <mat-icon svgIcon="cvx-left"></mat-icon>
    global settings
</a>

<div class="group-container header">
    <div class="header-title">deliverable templates</div>
<button
    class="adap-btn-filled add-mandatory-check-template-button"
    type="button"
    (click)="addDADeliverableTemplate()"
>
    add deliverable template <mat-icon svgIcon="cvx-plus-circle"></mat-icon>
</button>

<app-deliverable-templates-table
    (editDADeliverableTemplate)="editDADeliverableTemplate($event)"
    (deleteDADeliverableTemplate)="deleteDADeliverableTemplate($event)">
</app-deliverable-templates-table>
</div>